import { Component, Inject, Input } from '@angular/core';
import * as ReasonsActions from '../reasons/reasons.actions';
import { authenticatedPatientSelector, currentPatientSelector } from '../../../main/selectors/patients-selectors';
import { BreadcrumbElement } from '../../shared/models/breadcrumb-element.model';
import { Patient } from '../../shared/models/patient.model';

@Component({
  selector: 'top-navigation',
  template: require('./top-navigation.component.html'),
})

export class TopNavigationComponent {
  @Input() breadcrumbSteps: Array<BreadcrumbElement>;

  authenticatedPatient: Patient;
  currentPatient: Patient;

  ngReduxSubscription;

  constructor(
    @Inject('$ngRedux') public $ngRedux: any,
    @Inject('$state') public $state: any,
  ) { }

  ngOnInit() {
    this.ngReduxSubscription = this.$ngRedux.connect(state => ({
      authenticatedPatient: authenticatedPatientSelector(state),
      currentPatient: currentPatientSelector(state),
    }))(this);
  }

  ngOnDestroy() {
    if (this.ngReduxSubscription) {
      this.ngReduxSubscription();
    }
  }

  isStepCompleted(step) {
    const stepIndex = this.breadcrumbSteps.findIndex(listStep => (listStep === step));
    const currentIndex = this.breadcrumbSteps.findIndex(listStep => (listStep.stateName === this.$state.current.name));

    return stepIndex <= currentIndex;
  }

  isCurrentStep(step) {
    return step.stateName === this.$state.current.name;
  }

  goToHome() {
    this.$state.go('patients.id.home');
  }

  goToStep(step) {
    if (this.isStepCompleted(step)) {
      if (step.stateName === 'patients.id.reasons') {
        this.$ngRedux.dispatch(new ReasonsActions.UnsetCurrentReason());
      }
      this.$state.go(step.stateName);
    }
  }

  get backButtonLabel() {
    if (this.authenticatedPatient && this.currentPatient && this.authenticatedPatient.id !== this.currentPatient.id) {
      return 'breadcrumb.appointments_of';
    }

    return 'breadcrumb.my_appointments';
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/top-navigation/top-navigation.component.ts